export const setScrollListeners = () => {
  const documentElement = document.querySelector('html .multi-document');

  documentElement &&
    documentElement.addEventListener('scroll', () => {
      const navHeaderLinks = document.querySelectorAll('.jump-link');
      const scrollPos = documentElement.scrollTop;
      const navHeaderLinksArray = Array.from(navHeaderLinks);

      navHeaderLinksArray.forEach(currentLink => {
        const element = currentLink.getAttribute('id')?.substr(1).split('-')[1];
        const elementId = `#${element}`;
        const refElement: HTMLElement = document.querySelector(
          elementId.toUpperCase(),
        ) as HTMLElement;

        if (refElement) {
          if (
            // use - 173 to make sure document in view before setting .active
            refElement.offsetTop - 173 <= scrollPos &&
            refElement.offsetTop - 173 + refElement.offsetHeight > scrollPos
          ) {
            currentLink.classList.add('active');
            return;
          }
          if (
            documentElement.scrollHeight - documentElement.scrollTop ==
            documentElement.clientHeight
          ) {
            navHeaderLinksArray.forEach(link => {
              link.classList.remove('active');
            });
            navHeaderLinksArray[navHeaderLinksArray.length - 1].classList.add(
              'active',
            );
            return;
          } else {
            currentLink.classList.remove('active');
          }
        }
      });
    });
};
